<template>
    <div    class="">
        <ajax-table     :data="files"
                        :headers="headers"
                        v-model:loading="ajaxTable.loading"
                        v-model:search="ajaxTable.search"
                        v-model:sort-by="ajaxTable.sortBy"
                        v-model:sort-desc="ajaxTable.sortDesc"
                        v-model:page="ajaxTable.page"
                        v-model:items-per-page="ajaxTable.itemsPerPage"
                        v-model:page-info="ajaxTable.pageInfo"
                        no-data-message="No Files Found."
                        :row-selectable="false"
                        @loadData="getData"
                        :exportable="false"
                        :export-fetch-route="this.company.buildCompanyApiInternalRoute('device-file')"
                        :export-fetch-parameters="dataParameters"
        >
          <template #col-1="props">
            <div class="flex flex-col">
              {{props.row.name}}
              <span v-if="props.row.wifiSsidStatus === true"
                    class="inline-flex items-center rounded bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800">SSID Found!</span>
              <span v-if="props.row.wifiSsidStatus === false"
                    class="inline-flex items-center rounded bg-red-100 px-2 py-0.5 text-xs font-medium text-red-800">SSID not found in file</span>
            </div>
          </template>
            <template   #col-5="props">
                <undecorated-link   :href="props.row.link"
                                    target="_blank"
                >
                    <span   class="lnr icon-cloud-download"></span>
                </undecorated-link>
            </template>
        </ajax-table>
    </div>
</template>

<script>
import axios from "axios";
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link";

export default {
    name: "DeviceFilesIndex",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin],
    components: {UndecoratedLink, AjaxTable},
    props: {
        pointSerial: String,
    },
    data() {
        return {
            files: [],
            headers: [
                {
                    name: 'File Name',
                    key: 'name',
                    sortBy: 'fileName',
                },
                {
                    name: 'Description',
                    key: 'description',
                    sortBy: '',
                    size: 'lg',
                },
                {
                    name: 'Uploaded On',
                    key: 'uploadedOn',
                    sortBy: 'uploadedOn',
                    size: 'lg',
                },
                {
                    name: 'File Size',
                    key: 'size',
                    sortBy: '',
                    size: 'lg',
                },
                {
                    name: '',
                    sortBy: '',
                },
            ]
        }
    },
    created() {

    },
    mounted() {
        this.ajaxTable.sortBy = 'uploadedOn'
        this.ajaxTable.sortDesc = true
    },
    methods: {
        getData() {
            this.ajaxTable.requestNumber++
            this.ajaxTable.loading = true
            axios.get(this.company.buildCompanyApiInternalRoute('device-file'), {
                params: this.dataParameters
            }).then(response => {
                let data = response.data
                if (data.meta.requestNumber !== `${this.ajaxTable.requestNumber}`) {
                    return
                }

                if (!_.isNil(response.data)) {
                    this.files = data.data
                }

                this.ajaxUpdateTableData(data)
            }).catch(error => {
                console.log(error)
            }).then(() => {
                this.ajaxTable.loading = false
            })
        },
    },
    computed: {
        dataParameters() {
            let params = this.ajaxTable
            params.pointSerial = this.pointSerial

            return params
        },
    },
    watch: {
        pointSerial() {
            this.getData()
        }
    },
}
</script>

<style scoped>

</style>